'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionDetailsRepository', function ($resource) {
    var self = this;
    var detailsResource = $resource(
      '/api/v1/transactions/:transactionId/details',
      {},
      {
        update: { method: 'PATCH' }
      });

    self.update = function (transaction) {
      return detailsResource
        .update({ transactionId: transaction.id }, transaction)
        .$promise;
    };
  });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/TransactionDetailsRepository.js
// module id = 623
// module chunks = 0